<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  createOrUpdateBusinessTableZone(sizeId, degradingPotentialId, zoneId) {
    const payload = {
      degrading_potential_for_tax_id: degradingPotentialId,
      typology_size_for_tax_id: sizeId,
      zone_id: zoneId,
    };
    return axios.post('business_table_zones/create_or_update', payload, AS.getDefaultHeaders());
  },
};
</script>
